import { CartDetails } from "../cart/CartDetails";
import ContentfulCartTransformer from "../cart/ContentfulCartTransformer";
import FoundryPhysicalProduct from "./models/FoundryPhysicalProduct";
import { PhysicalProductDetailsArraySchema } from "./models/ResponseSchemas";
import Settings from "../../settings";
import { StartCheckoutResponse } from "./models/FoundryResponses";

class FoundryClient {
  static async shareCart(cartDetails: CartDetails): Promise<any> {
    return await fetch("/api/cart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(ContentfulCartTransformer.toJson(cartDetails)),
    }).then((response) => {
      // TODO: Actual sane error handling
      if (!response.ok) {
        if (response.status !== 400) {
          const message =
            "An unexpected error occurred while saving your cart.";
          return { errors: { code: "unexpected_error", message }, message };
        }
      }

      return response.json();
    });
  }

  static async getCsvDetails() {
    const res = await fetch("/api/admin/csv", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!res.ok) {
      throw new Error("response not ok");
    }

    return res.json();
  }

  static async getOrderPage(skip: number) {
    const res = await fetch("/api/admin/orders", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        skip,
      }),
    });

    if (!res.ok) {
      throw new Error("response not ok");
    }

    return res.json();
  }

  static async updateOrder(
    contentfulEntryId: string,
    trackingNumbers: string[]
  ) {
    const res = await fetch("/api/admin/orders/update", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        contentfulEntryId,
        trackingNumbers,
      }),
    });

    if (!res.ok) {
      throw new Error("response not ok");
    }

    return res.json();
  }

  static async confirmPackagedOrder(
    contentfulEntryId: string,
    trackingNumbers: string[],
    emailAddress: string,
    friendlyId: string
  ) {
    const res = await fetch("/api/admin/orders/confirmPackage", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        contentfulEntryId,
        trackingNumbers,
        emailAddress,
        friendlyId,
      }),
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return true;
  }

  static async startCheckout(
    cartDetails: CartDetails
  ): Promise<StartCheckoutResponse> {
    // TODO: Handle errors gracefully
    return await fetch("/api/checkout/start", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cartDetails,
      }),
    }).then((res) => {
      // if (res.ok || res.status === 422) {
      return res.json();
      // }
    });
  }

  static async updateCheckout(
    order_id: string,
    subtotal: number,
    shipping_amount: number,
    shipping_method: string,
    tax_amount: number,
    discount_amount: number
  ): Promise<any> {
    // TODO: Handle errors gracefully
    const res = await fetch("/api/checkout/update", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        order_id,
        subtotal,
        shipping_amount,
        tax_amount,
        shipping_method,
        discount_amount,
      }),
    });

    if (!res.ok) {
      throw new Error("Failed to update the checkout details.");
    }
  }

  static async completeCheckout(paymentIntentId: string): Promise<any> {
    return await fetch("/api/checkout/complete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payment_intent_id: paymentIntentId,
      }),
    }).then((response) => {
      // TODO: Actual sane error handling
      if (!response.ok) {
        if (response.status !== 400) {
          const message =
            "An unexpected error occurred while finalizing your checkout.";
          return { errors: { code: "unexpected_error", message }, message };
        }
      }

      return response.json();
    });
  }

  static async getPhysicalProducts(): Promise<FoundryPhysicalProduct[]> {
    return await fetch("/api/products", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": `max-age=${Settings.revalidate}`,
      },
    }).then(async (response) => {
      const jsonResponse = await response.json();
      const parseResult = PhysicalProductDetailsArraySchema.safeParse(
        jsonResponse.products
      );

      if (!parseResult.success) {
        // TODO: HANDLING ERRORS
        // // TODO: Sentry
        // console.error(
        //   "Error while parsing request body",
        //   parseResult.error,
        //   "data: ",

        // );

        // res.status(400).json({ error: parseResult.error });
        console.log(parseResult.error);
        return [];
      }

      const d = parseResult.data.map((res) => {
        return res as FoundryPhysicalProduct;
      });

      console.log({ d });
      return d;
    });
  }
}

export default FoundryClient;
